import ProductImage from '@moncler/components/product/ProductImage';
import { AccordionStepsActionTypes } from '@state/features/common.types';
import Button from '@ui/button/Button';
import addressutils from '@utils/addressutils';
import analytics from '@utils/analytics';
import api from '@utils/api';
import formutils from '@utils/formutils';
import { LG, MD, SM } from '@utils/imageutils';
import { calculateDateforJP } from '@utils/stringUtils';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import RegisterForm from '@components/login/RegisterForm';
import RegisteredInStoreCheckoutConfirm from '@components/login/RegisteredInStoreCheckoutConfirm';
const AftercareConfirm = (props) => {
    var _a, _b, _c;
    const { t } = useTranslation();
    const [product, setProduct] = useState();
    const [errors, setErrors] = useState([]);
    const dispatch = useDispatch();
    const returnFirstStep = () => {
        dispatch({
            type: AccordionStepsActionTypes.NAVIGATE_STEP,
            payload: 'customer',
        });
        analytics.aftercareNewRequest();
        props.startNewAfterCare();
    };
    useEffect(() => {
        let select = document.querySelector('.cs-form-container');
        const header = document.querySelector('header').offsetHeight;
        window.scrollTo({
            top: (select === null || select === void 0 ? void 0 : select.offsetTop) - header,
            behavior: 'smooth',
        });
        select === null || select === void 0 ? void 0 : select.focus();
        if (props.aftercareRequest.productCode) {
            api
                .getProductTile(props.aftercareRequest.productCode)
                .then((data) => {
                if (!data.error) {
                    setProduct(data);
                }
            })
                .catch((e) => {
                // setErrors([e]); ignore, could be an unknown product code
            });
        }
    }, []);
    return (React.createElement("div", { className: "aftercare confirm-aftercare" },
        React.createElement("div", { className: "container-aftercare" },
            React.createElement("p", { className: "primary-m-u request-received" }, t('aftercare.requyestreceived')),
            React.createElement("div", { className: "line" }),
            React.createElement("div", { className: "aftercare__title" },
                t('returns.thankyou'),
                ' ',
                addressutils.salutation(props.aftercareRequest.firstname, props.aftercareRequest.lastname, formutils.labelByValue(props.aftercareRequest.title, (_a = props.formdef) === null || _a === void 0 ? void 0 : _a.title))),
            React.createElement("div", { className: "aftercare__description" }, t('aftercare.completed', { date: 'date***' })),
            React.createElement("div", { className: "row" },
                props.casenumber && (React.createElement("div", { className: "col-6" },
                    React.createElement("div", { className: "col-6" },
                        React.createElement("p", { className: "detail-title primary-xs-u mb-16" }, t('aftercare.code')),
                        React.createElement("p", null, props.casenumber)))),
                React.createElement("div", { className: "col-6" },
                    React.createElement("p", { className: "detail-title primary-xs-u mb-16" }, t('label.date')),
                    React.createElement("p", null, calculateDateforJP(props.casedate)))),
            (props.loginStep == 'registeredInStoreSendEmail' || props.loginStep == 'registeredInStore') && (React.createElement("div", { className: "mt-24 mb-24 setup-password" },
                React.createElement(RegisteredInStoreCheckoutConfirm, { email: props.aftercareRequest.email }))),
            React.createElement("div", { className: "line" }),
            React.createElement("div", { className: "aftercare__subtitle" }, t('aftercare.requestsummary')),
            React.createElement("div", { className: "bag-product" },
                product && (React.createElement("div", { className: "col bag-product__image" },
                    React.createElement(ProductImage, { sizes: [LG, MD, SM], img: product.imgs, type: "F", tiletype: (product === null || product === void 0 ? void 0 : product.isMbm) ? 'mbm' : '' }))),
                React.createElement("div", { className: classNames('col bag-product__product-content', { 'bag-product__product-content__image': product }) },
                    React.createElement("div", { className: "bag-product__name-price" },
                        React.createElement("h3", { className: "bag-product__name-price__name" }, product ? product.productName : props.aftercareRequest.garmentName)),
                    React.createElement("div", { className: "bag-product__details" },
                        React.createElement("div", null,
                            React.createElement("p", null, t('aftercare.productcode', { code: props.aftercareRequest.productCode }))),
                        React.createElement("div", null,
                            React.createElement("p", null, t('findinboutique.size', { size: props.aftercareRequest.size }))),
                        React.createElement("div", null,
                            React.createElement("p", null, t('findinboutique.color', { color: props.aftercareRequest.colour })))))),
            React.createElement("div", { className: "wrapper" },
                React.createElement("div", { className: "col-12 row detail-row" },
                    React.createElement("div", { className: "col-6" },
                        React.createElement("p", { className: "detail-title" }, t('label.aftercare')),
                        React.createElement("p", null, props.aftercareRequest.details)),
                    React.createElement("div", { className: "col-6" },
                        React.createElement("p", { className: "detail-title" }, t('label.items')),
                        React.createElement("p", null, "1")))),
            React.createElement("div", { className: "line" }),
            React.createElement("div", { className: "row submit-button" },
                React.createElement("div", { className: "col-sm-6 d-none d-sm-flex " }),
                React.createElement("div", { className: "col-sm-6" },
                    React.createElement(Button, { type: "button", onClick: returnFirstStep, cls: ['button--primary'] }, t('aftercare.createnew'))))),
        props.loginStep == 'register' && (React.createElement("div", { className: "container-register-form mt-80" },
            React.createElement("h2", { className: "mb-24 title primary-l-u" }, t('aftercare.becomemember')),
            React.createElement("span", { className: "subtitle primary-s" }, t('aftercare.subtitle')),
            React.createElement("div", { className: "line divider-ty-page" }),
            React.createElement(RegisterForm, { inContactUs: true, phone: props.aftercareRequest.phone, phonePrefix: props.aftercareRequest.phonePrefix, firstName: props.aftercareRequest.firstname, lastName: props.aftercareRequest.lastname, localName: (_b = props.aftercareRequest) === null || _b === void 0 ? void 0 : _b.localname, localSurname: (_c = props.aftercareRequest) === null || _c === void 0 ? void 0 : _c.localsurname, loginEmail: props.aftercareRequest.email })))));
};
export default AftercareConfirm;
